import { ComponentType } from 'react';
import StyleToJS from 'style-to-js';

import { Element, Processor } from '@/features/html2react/types';

import NextImage, { ImageProps } from '../components/image';

interface ImageElement extends Element {
  props: Element['props'] &
    ImageProps & {
      duotoneFilter?: string;
      'data-src': string;
      'data-srcset': string;
      'data-erom-duotone': string;
    };
}

const image: Processor<ImageElement> = {
  priority: 97,
  name: 'image',
  test: ({ node }) => node.component === 'img',
  processor: ({ node }) => {
    if (node.parent?.component === 'noscript') return null;

    if (node.props['data-src']) {
      node.props.src = node.props['data-src'];
    }

    if (node.props['data-srcset']) {
      node.props.srcSet = node.props['data-srcset'];
    }

    if (node.props?.css?.styles) {
      const styles = StyleToJS(node.props.css.styles);
      if (styles.width) {
        node.props.width = styles.width;
      }
      if (styles.height) {
        node.props.height = styles.height;
      }
    }

    if (node.props['data-erom-duotone']) {
      node.props.duotoneFilter = node.props['data-erom-duotone'];
    }

    node.component = NextImage as ComponentType;

    return node;
  }
};

export default image;
